import { configureStore } from '@reduxjs/toolkit';
import realEstateReducer from './realEstateSlice';
import realEstateTypeReducer from './realEstateTypeSlice';

export const store = configureStore({
  reducer: {
    realEstates: realEstateReducer,
    realEstateTypes: realEstateTypeReducer,
  },
});
